export default __webpack_public_path__ + "a86870cd502338007622f90520a424c6.svg";